import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { ReactComponent as NoteIcon } from "assets/note.svg";
import { ReactComponent as PlusIcon } from "assets/plus.svg";
import { ReactComponent as EyeIcon } from "assets/eye.svg";
import { Button, StyledGrid } from "components/simple";
import { StyledMenu, StyledMenuItem } from "./styled";
import { color, spacingDefaults } from "style/constants";

interface NotesDropdownProps {
  userAssessmentCycleId: string;
  notesCallback(): void;
}

const NotesDropdown: React.FC<NotesDropdownProps> = ({
  notesCallback,
  userAssessmentCycleId
}: NotesDropdownProps) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        padding={spacingDefaults.normal}
        background="transparent"
        aria-controls="notes-menu"
        aria-haspopup="true"
        onClick={handleClick}
        textColor={color.BLUE}
        startIcon={<NoteIcon stroke={color.BLUE} />}
      >
        Notes
      </Button>
      <StyledMenu
        id="notes-menu"
        elevation={0}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <StyledMenuItem
          onClick={() => {
            handleClose();
            notesCallback();
          }}
        >
          <StyledGrid container alignItems="center">
            <PlusIcon />
            Add Note
          </StyledGrid>
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => {
            handleClose();
            history.push(`/internal-notes/${userAssessmentCycleId}`);
          }}
        >
          <EyeIcon />
          View Notes
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

export default NotesDropdown;
